import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://kale-admin.com/kale-web'
});

export default instance;